export const Name = 'funnel-location-question';

export enum VariantType {
  Control = 'control',
  AreaStep = 'area_step',
  Nudge = 'nudge',
}
